import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

async function readError(res, fallback) {
    try {
        const data = await res.json();
        return data?.detail || data?.message || fallback;
    } catch {
        try {
            const txt = await res.text();
            return txt || fallback;
        } catch {
            return fallback;
        }
    }
}

export async function getBillingSettings() {
    const res = await apiFetch(`${API_BASE}/billing/operator/settings`);
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося завантажити налаштування оплати"));
    }
    return await res.json();
}

export async function updateBillingSettings({ price_per_m2 }) {
    const res = await apiFetch(`${API_BASE}/billing/operator/settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ price_per_m2 }),
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося зберегти ціну за м²"));
    }
    return await res.json();
}

export async function listBillingExpenseItems() {
    const res = await apiFetch(`${API_BASE}/billing/operator/expenses`);
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося завантажити статті тарифу"));
    }
    return await res.json();
}

export async function updateBillingExpenseItems({ items }) {
    const res = await apiFetch(`${API_BASE}/billing/operator/expenses`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося зберегти статті тарифу"));
    }
    return await res.json();
}

export async function listClientBilling() {
    const res = await apiFetch(`${API_BASE}/billing/operator/clients`);
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося завантажити оплату клієнтів"));
    }
    return await res.json();
}

export async function listLocationBillingSettings() {
    const res = await apiFetch(`${API_BASE}/billing/operator/locations`);
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося завантажити локації для оплати"));
    }
    return await res.json();
}

export async function updateLocationBillingSettings({ location_id, price_per_m2 }) {
    const res = await apiFetch(`${API_BASE}/billing/operator/location/${location_id}/settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ price_per_m2 }),
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося зберегти ціну за м² для локації"));
    }
    return await res.json();
}

export async function upsertClientBilling({ client_id, context_id, area_m2, paid_amount, debt_amount }) {
    const res = await apiFetch(`${API_BASE}/billing/operator/client/${client_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ context_id, area_m2, paid_amount, debt_amount }),
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося зберегти оплату клієнта"));
    }
    return await res.json();
}

export async function previewBillingImport(file) {
    const formData = new FormData();
    formData.append("file", file);

    const res = await apiFetch(`${API_BASE}/billing/operator/import/preview`, {
        method: "POST",
        body: formData,
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося зчитати виписку"));
    }
    return await res.json();
}

export async function applyBillingImport({ file_name, items }) {
    const res = await apiFetch(`${API_BASE}/billing/operator/import/apply`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ file_name, items }),
    });
    if (!res.ok) {
        throw new Error(await readError(res, "Не вдалося рознести оплату з виписки"));
    }
    return await res.json();
}
